import React from 'react';
import { useBrand } from '../../context/AuthContext';
import Footer from './Footer';

const LoginFooter = () => {
  const { brand } = useBrand();

  return (
    <>
      <div className="text-center text-muted small">
        <p>
          The information provided within this web site is confidential and is provided
          by {brand.longName} for the sole purpose of processing utility assistance
          applications. Sharing or using the information for any other purpose is
          strictly prohibited.
        </p>
      </div>
      <Footer/>
    </>
  );
};

export default LoginFooter;
